import { useParams } from 'react-router-dom'
import { EvaluationRubricBuilder } from '@/components/admin/evaluation-rubrics/evaluation-rubric-builder'

type EvaluationRubricDetailPageProps = {
  onStartConversation?: (message: string) => void
}

/** Corpus-scoped guided rubric builder. */
export function EvaluationRubricDetailPage({
  onStartConversation,
}: EvaluationRubricDetailPageProps) {
  const { corpusId } = useParams<{ corpusId: string }>()
  return (
    <EvaluationRubricBuilder
      corpusId={corpusId}
      onStartConversation={onStartConversation}
    />
  )
}
